"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : BUTTON : STYLES --------------- ++++++++++ */


var _default = {
  button: {
    cursor: 'pointer',
    display: 'inline-flex',
    outline: 'none',
    position: 'relative',
    userSelect: 'none',
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'center',
    textTransform: 'none',
    transition: _index.theme.animation.general('all'),
    padding: (0, _index.replacePXinStringWithEM)('0px 10px'),
    border: '0',
    borderRadius: (0, _index.pxToEm)(5),
    width: (0, _index.pxToEm)(213),
    height: (0, _index.pxToEm)(48),
    fontSize: (0, _index.pxToEm)(16),
    fontWeight: '600',
    whiteSpace: 'nowrap',
    // icon
    '& .icon': {
      '& i': {
        fontSize: '150%',
        marginRight: (0, _index.pxToEm)(7)
      }
    },
    // text
    '& .text': {},
    // badge
    '& .badge': {
      marginLeft: (0, _index.pxToEm)(12)
    },
    // loader
    '& .loader': {
      display: 'none',
      fontSize: '38%',
      marginRight: (0, _index.pxToEm)(15) // marginTop: pxToEm(-20)

    },
    // ----- names ----- //
    '&.name-signingoogle': {
      background: '#DD4B39',
      color: '#fff'
    },
    // ----- variant ----- //
    '&.variant-primary': {
      background: _index.theme.color.primary.medium.swatch,
      color: _index.theme.color.primary.medium.contrast,
      '& .loader div': {
        borderTopColor: _index.theme.color.primary.medium.contrast
      }
    },
    '&.variant-secondary': {
      background: _index.theme.color.primary.light.swatch,
      color: _index.theme.color.primary.light.contrast,
      '& .loader div': {
        borderTopColor: _index.theme.color.primary.light.contrast
      }
    },
    '&.variant-normal': {
      background: _index.theme.color.supporting.light.swatch,
      color: _index.theme.color.supporting.light.contrast,
      '& .loader div': {
        borderTopColor: _index.theme.color.supporting.light.contrast
      }
    },
    '&.variant-system': {
      background: _index.theme.color.supporting.light.swatch,
      color: _index.theme.color.primary.medium.swatch,
      border: '0',
      '& .loader div': {
        borderTopColor: _index.theme.color.primary.medium.swatch
      }
    },
    '&.variant-disabled': {
      cursor: 'default',
      pointerEvents: 'none',
      background: _index.theme.color.neutral.light.swatch,
      color: _index.theme.color.neutral.medium.swatch
    },
    '&.variant-action': {
      background: _index.theme.color.secondary.medium.swatch,
      color: _index.theme.color.secondary.medium.contrast,
      '& .loader div': {
        borderTopColor: _index.theme.color.secondary.medium.contrast
      }
    },
    '&.variant-delete': {
      background: _index.theme.color.attention.medium.swatch,
      color: _index.theme.color.attention.medium.contrast,
      '& .loader div': {
        borderTopColor: _index.theme.color.attention.medium.contrast
      }
    },
    '&.variant-combination': {
      // background: linear-gradient(to right, #7ed321 0%,#1494f4 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      background: "linear-gradient(to bottom, ".concat(_index.theme.color.secondary.medium.swatch, " 0%, ").concat(_index.theme.color.primary.medium.swatch, " 100%)"),

      /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      color: _index.theme.color.secondary.medium.contrast,
      '& .loader div': {
        borderTopColor: _index.theme.color.secondary.medium.contrast
      }
    },
    '&.variant-control': {
      background: '#F3F6F8',
      borderRadius: (0, _index.pxToEm)(3),
      color: '#1494F4',
      padding: (0, _index.replacePXinStringWithEM)('5px 20px'),
      width: 'auto',
      height: 'auto',
      extend: _index.theme.typography.size.xsmall,
      border: 'none',
      '& .loader div': {
        borderTopColor: "#1494F4"
      }
    },
    // ----- colors ----- //
    // generates classes for every color in the theme ".color-(uniqueColor)"
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        background: theme.color[uniqueColor].medium.swatch,
        color: theme.color[uniqueColor].medium.contrast,
        '& .loader div': {
          borderTopColor: theme.color[uniqueColor].medium.contrast
        }
      };
    }),
    // +++++ states +++++ //
    '&:hover': {
      filter: 'brightness(93%)'
    },
    '&.iconRight-true': {
      '& .text': {
        order: '-1'
      },
      '& .icon': {
        '& i': {
          marginRight: '0',
          marginLeft: (0, _index.pxToEm)(7)
        }
      }
    },
    '&:disabled': {
      extend: _index.disable
    },
    '&.processing-true': {
      cursor: 'default',
      pointerEvents: 'none',
      '& .loader': {
        display: 'inline-block'
      }
    }
  }
};
exports.default = _default;